import { DlpSecondaryProductSummary } from 'components/secondaryMarket/dlpOrder/blocks/dlpSecondaryProductSummary';
import { DlpSecondaryTradeInformation } from 'components/secondaryMarket/dlpOrder/blocks/dlpSecondaryTradeInformation';

import { connectDlpSecondaryProductSummary } from './dlpSecondaryProductSummary.connect';
import { connectDlpSecondaryTradeInformation } from './dlpSecondaryTradeInformation.connect';

export const ConnectedDlpSecondaryProductSummary = connectDlpSecondaryProductSummary(DlpSecondaryProductSummary);
export const ConnectedDlpSecondaryTradeInformation = connectDlpSecondaryTradeInformation(DlpSecondaryTradeInformation);
